export const OperationSchedule = (json: IOperationSchedule): IOperationScheduleModel => {
	const fromJSON = () => {
		const { valid_until, earliest_available_date, blacklisted_days_skipped, ...rest } = json
		return {
			validUntil: valid_until ? new Date(valid_until) : null,
			earliestAvailableDate: earliest_available_date ? new Date(earliest_available_date) : null,
			blacklistedDaysSkipped: blacklisted_days_skipped,
			...rest,
		}
	}
	return { ...fromJSON() }
}

export const OperationScheduleType = (json: EOperationScheduleTypes): EOperationScheduleTypesModel => {
	const fromJSON = () => {
		const entries = Object.entries(json ?? {}).map(([key, value]) => {
			if (value === null) return [key, value]
			const parsed = OperationSchedule(value)
			return [key, parsed]
		})
		return Object.fromEntries(entries) as EOperationScheduleTypesModel
	}
	return { ...fromJSON() }
}
